<template>
  <b-container id="courses_container">
    <b-row>
      <b-col md="3">
        <div id="side_links">
          <Sidebar></Sidebar>
        </div>
      </b-col>
      <b-col md="9">
        <Loading v-if="$store.state.loading || !$store.getters['parcours/list']"></Loading>
        <transition name="fade">
          <div id="featured_content"
            v-if="$store.state.admin.featured_content && $store.state.admin.featured_content.length > 0">
            <FeaturedContent :content="$store.state.admin.featured_content"></FeaturedContent>
          </div>
        </transition>
        <transition name="fade">
          <div id="list_parcours" v-if="list_parcours_live.length > 0">
            <b-row class="equal-height">
              <b-col md="6" v-for="parcours in list_parcours_live" :key="parcours.id" class="col_parcours">
                <ParcoursItem :parcours="parcours"></ParcoursItem>
              </b-col>
            </b-row>
          </div>
        </transition>
        <transition name="fade">
          <div id="list_parcours" style="margin-top: 20px" v-if="list_parcours_non_classe.length > 0">
            <h2 class="align_left"><b-icon icon="dash" class="primary_color" aria-hidden="true"></b-icon>{{
              $t("tab_courses.courses_sans_classement") }}</h2>
            <b-row class="equal-height">
              <b-col md="6" v-for="parcours in list_parcours_non_classe" :key="parcours.id" class="col_parcours">
                <ParcoursItem :parcours="parcours"></ParcoursItem>
              </b-col>
            </b-row>
          </div>
        </transition>
        <transition name="fade">
          <div v-if="!$store.state.loading && !$store.getters['parcours/list']">
            <h3>{{ $t("tab_courses.erreur_parcours_manquants") }}</h3>
          </div>
        </transition>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Sidebar from "@/components/Courses_tab/Sidebar.vue";
import Loading from "@/components/Loading.vue";
import ParcoursItem from "@/components/Courses_tab/ParcoursItem.vue";
import FeaturedContent from "@/components/Courses_tab/FeaturedContent.vue";
import axios from "axios";
export default {
  components: { Sidebar, ParcoursItem, Loading, FeaturedContent },
  data() {
    return {
      list_parcours_live: [],
      list_parcours_non_classe: [],
    };
  },

  methods: {
    set_parcours_live() {
      var filtered = this.$store.getters['parcours/list'];
      if (!filtered) {
        return;
      }
      filtered = filtered.filter((item) => item.is_live);
      this.list_parcours_live = filtered;
    },
    set_parcours_non_classe() {
      var filtered = this.$store.getters['parcours/list'];
      if (!filtered) {
        return;
      }
      filtered = filtered.filter((item) => !item.is_live);
      this.list_parcours_non_classe = filtered;
    },
  },
  async created() {
    this.$store.commit("setLoading");
    var _this = this;
    let res;
    if (this.$store.state.module.nm == 1) {
      res = await axios.get(this.$store.state.base_url + "/nm/parcours/get.php?id=" + this.$store.state.module.id + "&base=" + this.$store.state.module.base);
    } else {
      res = await axios.get(this.$store.state.base_url + "/parcours/get.php?id=" + this.$store.state.module.id + "&base=" + this.$store.state.module.base);
    }

    if (res.data) {
      this.$store.commit("setParcours", res.data);

      this.set_parcours_live();
      this.set_parcours_non_classe();
    }
    this.$store.commit("unsetLoading");
  },
};
</script>

<style lang="sass" scoped>
</style>